/* eslint-disable max-len */
import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

export const MenuEmailMarketingIcon: FC<CommonIconProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.0225 4.12238C4.26101 4.04351 4.5218 4 4.80189 4H19.1981C19.4782 4 19.739 4.04352 19.9776 4.1224C21.1483 4.47528 22 5.55112 22 6.82353V17.1765C22 18.7359 20.7208 20 19.1429 20H4.85714C3.27919 20 2 18.7359 2 17.1765V6.82353C2 5.55109 2.85172 4.47524 4.0225 4.12238ZM4.60548 5.72159C4.68645 5.70361 4.77067 5.69412 4.85714 5.69412H19.1429C19.2293 5.69412 19.3136 5.70361 19.3946 5.7216C19.8763 5.86252 20.0505 6.51101 19.6232 6.86049L12 13.0951L4.37685 6.86049C3.94952 6.51101 4.12371 5.8625 4.60548 5.72159ZM20.2857 8.51765V17.1765C20.2857 17.8002 19.774 18.3059 19.1429 18.3059H4.85714C4.22596 18.3059 3.71429 17.8002 3.71429 17.1765V8.51764L11.6964 15.0458C11.8726 15.1899 12.1275 15.1899 12.3036 15.0458L20.2857 8.51765Z"
      fill="currentColor"
    />
  </svg>
);
